/** Toyota-branded chart colors mapped from toyota_colors.py */
export const TOYOTA_RED = "#EB0A1E";
export const TOYOTA_DARK_RED = "#C4161C";
export const SUCCESS_GREEN = "#00B140";
export const WARNING_ORANGE = "#FF8C00";
export const INFO_BLUE = "#0071CE";
export const ACCENT_BLUE = "#4A90E2";

export const CHART_COLORS = [
  "#EB0A1E",
  "#0071CE",
  "#00B140",
  "#FF8C00",
  "#7B68EE",
  "#20B2AA",
  "#FFD700",
  "#FF69B4",
];

export const KPI_COLORS = {
  excellent: "#00B140",
  good: "#7CB342",
  warning: "#FF8C00",
  critical: "#DC143C",
  neutral: "#8A8D8F",
};

export const ENV_COLORS: Record<string, string> = {
  DEV: TOYOTA_RED,
  QA: INFO_BLUE,
  PROD: SUCCESS_GREEN,
};

export const plotlyLayout = {
  paper_bgcolor: "transparent",
  plot_bgcolor: "transparent",
  font: { family: "'Inter', 'Roboto', sans-serif", color: "#64748B", size: 11 },
  margin: { t: 20, r: 20, b: 40, l: 50 },
  legend: { orientation: "h" as const, y: -0.2 },
  xaxis: { gridcolor: "#F1F5F9", linecolor: "#E2E8F0", tickfont: { color: "#94A3B8", size: 11 } },
  yaxis: { gridcolor: "#F1F5F9", linecolor: "#E2E8F0", tickfont: { color: "#94A3B8", size: 11 }, zeroline: false },
  hoverlabel: { bgcolor: "#1B2559", font: { color: "#FFFFFF", size: 13 }, bordercolor: "#1B2559" },
};
